<template>
	<div>
		<ManagingSection>
			<ManagingBox>
				<CheckboxList
					:value="causeIds"
					:verticalUl="true"
					:checkboxList="causeList"
					@input="causeIdsInput"
				/>
			</ManagingBox>
		</ManagingSection>
		<div class="btn-wrap-main">
			<button class="btn-main orange" type="button" @click="blindBatch">
				블라인드 처리
			</button>
		</div>
	</div>
</template>
<script>
	import { mapState } from 'vuex';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import CheckboxList from '@/components/CheckboxList.vue';

	export default {
		name: 'ToBlindBatch',
		components: {
			ManagingSection,
			ManagingBox,
			CheckboxList,
		},
		data() {
			return {
				causeIds: [],
			};
		},
		computed: {
			...mapState({
				causeList: state =>
					state.notice.causeList.map(({ value, name }) => ({
						id: value,
						value: name,
					})),
				params: state => state.modal.params,
			}),
		},
		methods: {
			async causeIdsInput(list) {
				if (list.length > 2)
					alert('블라인드 사유는 2개까지 선택 가능합니다.');
				await this.$nextTick();
				this.causeIds = list.slice(0, 2);
			},
			async blindBatch() {
				try {
					if (!confirm('현재 목록 모두 블라인드처리하시겠습니까?'))
						return;
					await this.$axiosAdmin2.post('/v3/api/review/report/bulk', {
						idReviewCommentList: this.params.list,
						reportReviewState: 'F',
						reviewCommentState: 'B',
						causeIds: this.causeIds,
					});
					window.location.reload();
				} catch (err) {
					console.error(err);
					alert('일괄작업실패! 개발팀에 문의하세요.');
				}
			},
		},
	};
</script>
